export default __webpack_public_path__ + "static/media/phone.21d06f88.svg";